module.exports = __webpack_public_path__ + "img/3.553d461a.png";